import {Component, OnInit} from '@angular/core';
import 'rxjs/add/operator/takeWhile';
import {SettingsService} from "../core/settings/settings.service";
import { HeaderComponent } from '../layout/header/header.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';
import { RmsService } from '../../../projects/jv-common/src/public_api';

const swal = require('sweetalert');

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

    deviceInfo = null;
    constructor(private router: Router, public settings: SettingsService, private device: DeviceDetectorService, private rms: RmsService)
    {
    }

    ngOnInit() {
    }
    onActivate(event) {
        HeaderComponent.setTitle(localStorage.getItem('shopAddress'));

        this.deviceInfo = this.device.getDeviceInfo();
        const isMobile = this.device.isMobile();
        const isTablet = this.device.isTablet();
        const isDesktopDevice = this.device.isDesktop();

        if (isMobile) {
            swal({
                title: 'Xin chú ý!',
                text: 'Hệ thống báo cáo được tối ưu cho màn hình cỡ lớn\n(tablet hoặc máy tính)',
                type: 'warning',
                icon: "warning",
            });
        }
    }

    doLogout($event) {

        if ($event === 'logout'){ this.rms.logout();}
    }
}
